import { useCallback } from 'react'

import { useQueryClient } from '@tanstack/react-query'

import useApiPost from 'Pods/Shared/Hooks/useApiPost'
import useRequireGenerationAccess from 'Pods/ThreeDStudio/Hooks/useRequireGenerationAccess'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

const showNotification = (message, type) => {
  if (typeof window !== 'undefined' && window.showNotification) {
    window.showNotification(message, { type, autohide: true })
  }
}

// Regenerates an image run from the library through the same endpoint the Create
// conversation uses. There is no conversation to draw the new run into here, so its
// progress shows as a processing card instead: the refetch puts the requested run at the
// top of the Images tab, and the tab polls while any run is in flight.
function useRegenerateImageRun() {
  const t = useTranslation()
  const queryClient = useQueryClient()
  const { postData, isLoading } = useApiPost()
  const { requireGenerationAccess } = useRequireGenerationAccess()

  const regenerateImage = useCallback((runId) => {
    if (runId == null || !requireGenerationAccess()) return

    postData({
      path: `/api/internal/generator/image-generations/${runId}/regenerate`,
      data: {},
      onSuccess: () => {
        queryClient.refetchQueries({ queryKey: ['libraryItems', 'images'], exact: false })
      },
      onError: () => {
        showNotification(t('shared.generateButton.genericError'), 'error')
      },
    })
  }, [postData, queryClient, requireGenerationAccess, t])

  return { regenerateImage, isLoading }
}

export default useRegenerateImageRun
